<div class="content-wrapper" *ngIf="!hasUserApprovedContract">
    <div class="row">
      <div class="col-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title"> Approve Movement Request</h4>
           <h5>Requesters Details</h5>
            <form class="forms-sample" #ngNewMovementForm="ngForm" name="form"
              >
        
             


               <div style="background: #ECECEC;padding:30px;">
                <div class="row">
                  <div class="col">
                    <div style="background: white;padding:5px; justify-content: center;" class="form-group">
                      <label style="justify-content: center;"  for="description">Requester Name</label>
                    
                      <p>{{ contract?.requesterName  }}</p>
                    </div>
                  </div>
                  <!-- Designation -->
                  <div class="col">
                    <div style="background: white;padding:5px;" class="form-group">
                      <label for="exampleInputCity1">Requester Designation</label>
                      <p>{{ contract?.requesterDesignation  }}</p>
                    
                    </div>
                  </div>
  
                    <!-- Function  -->
                    <div class="col">
                      <div  style="background: white;padding:5px;" class="form-group">
                        <label for="selectedfunction">Requester Function</label>
                        <p>{{ contract?.requesterFunction }}</p>
                        
                      </div>
                    </div>
              </div>
                  <div class="row">
                 
    
                  <!-- Unit  -->
                  <div class="col">
                    <div style="background: white;padding:5px;" class="form-group">
                      <label for="selectedRequesterFunctionId">Requester Unit</label>
                   
                      <p>{{ contract?.requesterUnit }}</p>
                    </div>
                  </div>
                 <!-- Request Date  -->
                  <div class="col">
                    <div style="background: white;padding:5px;" class="form-group">
                      <label for="exampleInputCity1">Request Date</label>
                      <p>{{ contract?.requestDate | date: 'dd/MM/yyyy'}}</p>
                     
                    </div>
                  </div>
                   
                 
                </div>
              </div>
              <h5> Current Employee Data</h5>
              <br>
              <div style="background: #ECECEC;padding:30px;">
               <div class="row">
              
                 <!-- Employee Name -->
                 <div class="col">
                   <div style="background: white;padding:5px;" class="form-group">
                     <label  for="exampleInputCity1">Employee Name</label>
                     <p>{{ contract?.employeeName }}</p>
                   </div>
                 </div>

                   <!-- SAP Number  -->
             <div class="col">
               <div style="background: white;padding:5px;" class="form-group">
                 <label  for="description">SAP Number</label>
                 <p>{{ contract?.employeeSAPNumber }}</p>
               </div>
             </div>

             <div class="col">
               <div style="background: white;padding:5px;" class="form-group">
                 <label for="costCenter">Band</label>
                 <p>{{ contract?.employeeBand }}</p>
               </div>
             </div>
                 
             </div>
                 <div class="row">
                
                <div class="col">
                 <div style="background: white;padding:5px;" class="form-group">
                   <label for="exampleInputCity1">Designation</label>
                   <p>{{ contract?.employeeDesignation }}</p>
                 </div>
               </div>

                  <!-- Function  -->
                   <div class="col">
                     <div style="background: white;padding:5px;" class="form-group">
                       <label for="selectedfunction">Function</label>
                       <p>{{ contract?.employeeUnit }}</p>
                     </div>
                   </div> 
                 <!-- Unit  -->
                 <div class="col">
                   <div style="background: white;padding:5px;" class="form-group">
                     <label for="selectedfunction">Unit</label>
                  
                     <p>{{ contract?.employeeUnit }}</p>
                   </div>
                 </div>
               </div>

        <div class="row">
         <!-- N+1 Designation  -->
           <div class="col">
               <div style="background: white;padding:5px;" class="form-group">
                 <label for="description">N + 1 </label>
                 <p>{{ contract?.employeeNPlus1 }}</p>
               </div>
             </div>

     <!-- Location  -->
     <div class="col">
       <div style="background: white;padding:5px;" class="form-group">
         <label for="selectedLocation">Location</label>
         <p>{{ contract?.employeeCurrentLocation }}</p>
       </div>
     </div>
       <!-- Last Promotion Date  -->
       <div class="col">
           <div style="background: white;padding:5px;" class="form-group">
             <label for="exampleInputCity1">Last Promotion Date</label>
             <p>{{ contract?.lastPromotionDate | date: 'dd/MM/yyyy'}}</p>
           </div>
         </div>
       </div>

       <div class="row">
 <!-- DATE ASSUMED CURRENT ROLE  -->
 <div class="col">
   <div style="background: white;padding:5px;" class="form-group">
     <label for="exampleInputCity1">DATE ASSUMED CURRENT ROLE</label>
     <p>{{ contract?.datAssumeCurrentRole | date: 'dd/MM/yyyy'}}</p>
   </div>
 </div>
       </div>
          </div>
            
             <br>
 
 
             <h5> Proposed Employee Data</h5>
             <br>
            
          <div style="background: #ECECEC;padding:30px;">
           <div class="row">
 
             <!-- PROPOSED DESIGNATION -->
    
             <div class="col">
               <div style="background: white;padding:5px;" class="form-group">
                 <label for="exampleInputCity1">PROPOSED DESIGNATION</label>
                 <p>{{ contract?.proposedDesignation }}</p>
               </div>
             </div>

 
             <!--Proposed N+1   -->
             <div class="col">
               <div style="background: white;padding:5px;"class="form-group">
                 <label for="description">Proposed N + 1</label>
                 <p>{{ contract?.proposedNPlus1 }}</p>
 
               </div>
             </div>

               <!--Proposed Function  -->
               <div class="col">
                   <div style="background: white;padding:5px;" class="form-group">
                     <label for="selectedfunction">Proposed Function</label>
                    
                     <p>{{ contract?.proposedFunction }}</p>
                   </div>
                 </div> 

               </div>`

               <div class="row">
                     <!--Proposed Unit  -->
                 <div class="col">
                   <div style="background: white;padding:5px;" class="form-group">
                     <label for="selectedfunction">Proposed Unit</label>
                     <p>{{ contract?.proposedUnit }}</p>
                    
                   </div>
                 </div>

                  <!-- EFFECTIVE DATE  -->
           <div class="col">
               <div style="background: white;padding:5px;" class="form-group">
                 <label for="exampleInputCity1">EFFECTIVE DATE</label>
                 <p>{{ contract?.effectiveDate | date: 'dd/MM/yyyy'}}</p>
               </div>
             </div>
 <!--Proposed Band  -->
             <div class="col">
               <div style="background: white;padding:5px;" class="form-group">
                 <label for="proposedBand">Proposed Band</label>
                 <p>{{ contract?.proposedBand }}</p>
               </div>
             </div>

               </div>
 
             
              
         
           <div class="row">
             <!--Proposed Cost Center  -->
  <div class="col">
      <div style="background: white;padding:5px;" class="form-group">
        <label for="costCenter">Proposed Cost Center</label>
        <p>{{ contract?.proposedCostCenter }}</p>
      </div>
    </div>

      <!--Proposed Location  -->
      <div class="col">
       <div style="background: white;padding:5px;" class="form-group">
         <label for="selectedLocation">Proposed Location</label>
         <p>{{ contract?.proposedLocation }}</p>
       </div>
     </div>
 </div>


        </div>
        <br>
         <h5> Role Details</h5>
         <br>
         <div style="background: #ECECEC;padding:30px;">
            <div class="row">
                <!-- Date Vacancy Occured  -->
                <div class="col">
                  <div style="background: white;padding:5px;" class="form-group">
                    <label for="exampleInputCity1">Date Vacancy Occured</label>
                    <p>{{ contract?.dateVacancyOccured }}</p>
                  </div>
                </div>
              <!-- Reasn For Vacancy -->
              <div class="col">
                <div style="background: white;padding:5px;" class="form-group">
                  <label for="exampleTextarea1">Reason For Vacancy</label>
                  <p>{{ contract?.reasonForVacancy }}</p>
                </div>
              </div>

              <div class="col">
                <div style="background: white;padding:5px;" class="form-group">
                  <label for="exampleTextarea1">Justification For Movement:</label>
                  <p>{{ contract?.justificationForVacancy }}</p>
                </div>
              </div>
                 
             </div>

         <div style="background: #ECECEC;padding:30px;">

          <div style="background: white;padding:5px;" class="form-group">

            <div class="row">
              <!-- Date Vacancy Occured  -->
              <div class="col">
                <div style="background: white;padding:5px;" class="form-group">
                  <label for="exampleInputCity1">Type Of Movements</label>
                  <p>{{ contract?.typeOfMovement }}</p>
                </div>
              </div>
            <!-- Reasn For Vacancy -->
            <div class="col">
              <div style="background: white;padding:5px;" class="form-group">
                <label for="exampleTextarea1">Systems Requirements</label>
                <p>{{ contract?.systemRequirementForNewRole }}</p>
              </div>
            </div>
           </div>


            <!-- <label> Type Of Movements</label>
            
              <br>
                <label> Systems Requirements</label>
                <br>
              
                <p>{{ contract?.systemRequirementForNewRole }}</p> -->
          </div>
          
              </div>
       
         </div>
         <br>
         <h5> Succession Plan & Transition</h5>
         <br>
        
         <div style="background: #ECECEC;padding:30px;">
          <h4>Job Performance / Performance Review (If Applicable)</h4>
            <div class="row">
              <div class="col">
                <div style="background: white;padding:5px;" class="form-group">
                  <label for="exampleTextarea1">Last Year</label>
                  <p>{{ contract?.performanceLastYear }}</p>
                </div>
              </div>
              <div class="col">
                <div  style="background: white;padding:5px;" class="form-group">
                  <label for="exampleTextarea1">2 Years</label>
                  <p>{{ contract?.twoYearsPerformance }}</p>
                </div>
              </div>

              <div class="col">
                <div style="background: white;padding:5px;" class="form-group">
                  <label for="exampleTextarea1">3 Years</label>
                  <p>{{ contract?.threeYearsPerformance }}</p>
                  
                </div>
              </div>
            </div>
          
            <div class="row">
              <div class="col">
                <div style="background: white;padding:5px;" class="form-group">
                  <label for="exampleTextarea1">Last Talent Review Grid/Comments</label>
                  <p>{{ contract?.lastTalentReviewComment }}</p>
                  
                </div>
              </div>

              <div class="col">
                <div style="background: white;padding:5px;" class="form-group">
                  <label for="talentReview">Succession Plan Ready</label>
                  <p>{{ contract?.successionPlanReady }}</p>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div style="background: white;padding:5px;" class="form-group">
                  <label for="exampleInputCity1">Development Plan</label>
                  <p>{{ contract?.developmentPlan }}</p>
                </div>
              </div>

              <div class="col">
                <div style="background: white;padding:5px;" class="form-group">
                  <label for="exampleInputCity1">Identified Gaps</label>
                  <p>{{ contract?.identifiedGaps }}</p>
                </div>
              </div>
            </div>
              <!-- <div class="row">
                <div class="form-group">
                  <label for="document" class="control-label col-md-10">Supporting Information</label>
                  <div class="col-md-10">
                    <input type="file" (change)="onFileChange($event)" placeholder="Upload file" [(ngModel)]="file"
                      accept=".pdf,.doc,.docx,.jpg,.jpeg,.xls,.xlsx,.png,.msg,.csv,.zip" #fileInput name="fileInput" style="padding-top:2px;"
                      class="form-control">
                  </div>
                </div>
  
              </div> -->

              <div class="col">
                <div style="background: white;padding:5px;" class="form-group">
                  <label for="exampleTextarea1">Comments</label>
                  <p>{{ contract?.requesterComment }}</p>
                </div>
              </div>
            


              
            </div>
    

            <div *ngIf="showthedoc">
                <nz-space>
                   
                    <button *nzSpaceItem nz-button nzType="primary" (click)="showDocument()">View document</button>
                  </nz-space>
            </div>
         <br>
         
  
           <br>
            <hr>
                            <!-- Approvals -->
   <div class="card-body" >
    <h5 class="card-title">Approvals</h5>
    <div class="table-responsive" >
      <table class="table table--striped table-hover">
        <thead>
          <tr>

            <th>
              Approved By
            </th>
            <th>
              Date Approved
            </th>
            <th>
              Message
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let approval of RequestApprovals">

            <td>{{approval.approvedBy}}</td>
            <td>{{approval.dateOfApproval | date: 'dd MMMM yyyy hh:mm a'}}</td>
            <td>{{approval.message}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="!RequestApprovals?.length"
      style="color: rgba(128, 128, 128, 0.741); text-align: center; padding: 18px;">
      <h4 style="color: rgba(128, 128, 128, 0.741);">No approval has been granted.</h4>
    </div>
    <!-- Approvals -->
  </div>
           
          
  
  
            <hr>

            
      <div class="row">
        <!-- Comment  -->
        <div class="col">
           <div class="form-group">
             <label for="exampleTextarea1">Comment</label>
             <textarea class="form-control" id="Comment" rows="4" name="Comment" [(ngModel)]="Comment"
               required #EComment="ngModel" ></textarea>
       
            
           </div>
         </div>
       
             </div>
            <div >
                <div style="float: right" class="d-print-none">
                
                  <a   nz-popconfirm
                  nzPopconfirmTitle="Are you sure?"
                  nzOkText="ok"
                  nzCancelText="cancel"
                  (nzOnConfirm)="approveContract()"
                  (nzOnCancel)="cancelReturn()"
                  > 
                    <span style="margin-right: 8px;" class="btn btn-primary">
                        Approve
                    </span>
                </a> 
                
                <a   nz-popconfirm
                nzPopconfirmTitle="Are you sure?"
                nzOkText="ok"
                nzCancelText="cancel"
                (nzOnConfirm)="rejectContract()"
                (nzOnCancel)="cancelReturn()"
                > 
                  <span style="margin-right: 8px;"class="btn btn-danger">
                      Reject
                  </span>
              </a> 
                  
                  
               
                </div>
           
           
              </div>
             
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>



  <div class="content-wrapper" *ngIf="hasUserApprovedContract">
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title"> </h4>
         
  
            <div  style="text-align: center; padding: 18px;">
              <h4 style="color: rgba(128, 128, 128, 0.741); ">This request has been approved</h4>
            </div>

                          <!-- Approvals -->
<div class="card-body" >
<h5 class="card-title">Approvals</h5>
<div class="table-responsive" >
  <table class="table table--striped table-hover">
    <thead>
      <tr>

        <th>
          Approved By
        </th>
        <th>
          Date Approved
        </th>
        <th>
          Message
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let approval of RequestApprovals">

        <td>{{approval.approvedBy}}</td>
        <td>{{approval.dateOfApproval | date: 'dd MMMM yyyy hh:mm a'}}</td>
        <td>{{approval.message}}</td>
      </tr>
    </tbody>
  </table>
</div>
<div  style="text-align: center; padding: 18px;">
    <button class="btn btn-primary" style="margin-right: 8px;"  (click)="cancel()">Close</button>
  </div>


<div *ngIf="!RequestApprovals?.length"
  style="color: rgba(128, 128, 128, 0.741); text-align: center; padding: 18px;">
  <h4 style="color: rgba(128, 128, 128, 0.741);">No approval has been granted.</h4>
</div>
<!-- Approvals -->
</div>
     
          </div>
        </div>
      </div>
  
  
    </div>
  </div>















  <nz-drawer

  [nzVisible]="visible"
  nzPlacement="right"
  [nzTitle]="doctitle"
 
  (nzOnClose)="close()"
>
  <ng-container *nzDrawerContent>
    <div class="pdf-container">
      <iframe id="ifrm" width="600" height="780" style="position: absolute;top: 66px;bottom: 0px;right: 0px;width: 100%;border: none;margin: 0;padding: 0;overflow: hidden;z-index: 3;height: 100%;"></iframe>
     
    </div>
  </ng-container>
</nz-drawer>
 

